import { useEffect } from "react";

interface HeadOptions {
  title: string;
  description: string;
  ogImage?: string;
  ogType?: string;
  canonical?: string;
}

const BASE_URL = "https://www.thesecrettrends.com";
const SITE_NAME = "The Secret Trends";
const DEFAULT_OG_IMAGE = `${BASE_URL}/favicon.svg`;

function setMeta(property: string, content: string, isProperty = false) {
  const attr = isProperty ? "property" : "name";
  let el = document.querySelector(`meta[${attr}="${property}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, property);
    document.head.appendChild(el);
  }
  el.content = content;
}

function setCanonical(href: string) {
  let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement("link");
    el.rel = "canonical";
    document.head.appendChild(el);
  }
  el.href = href;
}

export function useDocumentHead({ title, description, ogImage, ogType = "website", canonical }: HeadOptions) {
  useEffect(() => {
    const fullTitle = title === SITE_NAME ? title : `${title} | ${SITE_NAME}`;
    document.title = fullTitle;

    setMeta("description", description);
    setMeta("og:title", fullTitle, true);
    setMeta("og:description", description, true);
    setMeta("og:type", ogType, true);
    setMeta("og:image", ogImage || DEFAULT_OG_IMAGE, true);
    setMeta("og:site_name", SITE_NAME, true);
    setMeta("og:url", canonical || window.location.href, true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", description);

    const canonicalUrl = canonical || `${BASE_URL}${window.location.pathname}`;
    setCanonical(canonicalUrl);
  }, [title, description, ogImage, ogType, canonical]);
}
